import { Component, inject, input, output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ImagesService } from '../../../../services/general/images.service';
import { Loan } from '../../../../interfaces/responses/loan.interface';
import { LoanStatusStylePipe, LoanStatusLabelPipe } from '../../../../pipes/loan-status.pipe';

@Component({
  selector: 'app-single-product-overview-table',
  imports: [
    CommonModule,
    LoanStatusStylePipe,
    LoanStatusLabelPipe,
  ],
  templateUrl: './single-product-overview-table.component.html',
  styleUrl: './single-product-overview-table.component.scss'
})
export class SingleProductOverviewTableComponent {
  _images = inject(ImagesService);

  loan = input.required<Loan>();
  productId = input<string>('');

  onView = output<Loan>();
  onApprove = output<Loan>();
  onReject = output<Loan>();
  onCounter = output<Loan>();
  onDisburse = output<Loan>();

  triggerView() {
    this.onView.emit(this.loan());
  }

  triggerApprove() {
    this.onApprove.emit(this.loan());
  }

  triggerReject() {
    this.onReject.emit(this.loan());
  }

  triggerCounter() {
    this.onCounter.emit(this.loan());
  }

  triggerDisburse() {
    this.onDisburse.emit(this.loan());
  }
}
